module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-GBStV_1.8c502105.jpg";